/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class PastDueBanner extends React.Component {
    constructor(props) {
        super(props);

        this.onBillingClick = this.onBillingClick.bind(this);

    }

    componentDidMount() {

        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionView',
        //         'ecommerce': {
        //             'promoView': {
        //                 'promotions': [
        //                     {
        //                         'id': 'past_due_banner',
        //                         'name': 'Past Due Banner',
        //                         'creative': 'past_due_banner.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'past_due_banner',
        //         'promotion_name': 'Past Due Banner',
        //         'creative_name': 'past_due_banner.1',
        //         'creative_slot': 'top-promo-bar'
        //     });
        // }

        if (gtag) {
            gtag('event', 'view_promotion', {
                //GA 4 params
                'promotion_id': 'past_due_banner',
                'promotion_name': 'Past Due Banner',
                'creative_name': 'past_due_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner View',
                event_data: {
                    banner: 'Past Due Banner'
                }
            });
        }

    }

    onBillingClick(e) {

        var that = this;

        if (mixpanel) {
            mixpanel.track('Past Due Click');
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner Click',
                event_data: {
                    banner: 'Past Due Banner'
                }
            });
        }

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'past_due_banner',
        //                         'name': 'Past Due Banner',
        //                         'creative': 'past_due_banner.1',
        //                         'position': 'top-promo-bar'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'past_due_banner',
        //         'promotion_name': 'Past Due Banner',
        //         'creative_name': 'past_due_banner.1',
        //         'creative_slot': 'top-promo-bar',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'past_due_banner',
                'promotion_name': 'Past Due Banner',
                'creative_name': 'past_due_banner.1',
                'creative_slot': 'top-promo-bar',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'past_due_banner',
                'promotion_name': 'Past Due Banner',
            });
        }

    }

    render() {
        return (
            <div>
                <div className="icon-wrapper">
                    <i className="fa fa-warning banner-icon"/>
                </div>
                {"Your last payment didn't complete."} <a href="/account/billing" onClick={this.onBillingClick}>{"Review and update your billing details >>"}</a>
            </div>
        );
    }

};

PastDueBanner.displayName = "PastDueBanner";

export default PastDueBanner;
